import { useMemo } from 'react';
import { useGetAboutMeColleagueFeedbackQuery } from '../api/colleagueFeedbackApi';
import { FEEDBACK_PAGE_SIZE } from '../constants';
import { mapAboutMeFeedbackItems } from '../helpers/mapAboutMeEntries';

export function useAboutMeEntries(page: number, enabled: boolean) {
  const { data, isLoading, isFetching, isError, refetch } = useGetAboutMeColleagueFeedbackQuery(
    { page, pageSize: FEEDBACK_PAGE_SIZE },
    { skip: !enabled }
  );

  const entries = useMemo(() => mapAboutMeFeedbackItems(data?.items ?? []), [data]);

  const totalCount = data?.totalCount ?? 0;

  return { entries, totalCount, isLoading, isFetching, isError, refetch };
}
